import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import Root from '@/root';

if (import.meta.env.VITE_APP_ENV !== 'localhost') {
  Sentry.init({
    dsn: 'https://64038e4d40a3ddb86d71ee5169a8b918@sentry-prime.fast.onetrading.com/8',
    environment: import.meta.env.VITE_APP_ENV,
    sendDefaultPii: true,
  });
}

// biome-ignore lint/style/noNonNullAssertion: Vite should always have a root element
createRoot(document.getElementById('root')!).render(<Root />);
